import Turndown from 'turndown';
export const toMarkdown = html => {
  const turndown = new Turndown({
    headingStyle: 'atx'
  });
  Turndown.prototype.escape = value => value;
  return turndown.turndown(html);
};